import React from 'react';
import Orders from './Orders';

function OrdersDelivered() {
  return <Orders status="delivered" />;
}

export default OrdersDelivered;
